
import { sendPost } from '../http.js'
const api = {
	'dyOpenAuth': {
	    url: '/message/douyin/open/auth'
	},
	'dyAuthorBind': {
	    url: '/author/bind/open'
	},
	'dyBindInfo': {
	    url: '/open/bind/info '
	},
	
	'replyList': {
	    url: '/message/fast/reply'
	},
	'replyTop': {
	    url: '/message/fast/reply/top'
	},
	'replyAddoredit': {
	    url: '/message/fast/reply/addoredit'
	},
	'replyShowHide': {
	    url: '/message/reply/showhide'
	},
	'replyDel': {
	    url: '/message/reply/del'
	},
	'groupList': {
	    url: '/message/fast/reply/group'
	},
	'groupAdd': {
	    url: '/message/fast/reply/group/add'
	},
	'groupEdit': {
	    url: '/message/fast/reply/group/edit'
	},
	'groupDel': {
	    url: '/message/fast/reply/group/del'
	},
	'autoReply': {
	    url: '/message/auto/reply'
	},
	'autoAddoredit': {
	    url: '/message/auto/reply/addoredit'
	},
	'autoReplyTop': {
	    url: '/message/auto/reply/top'
	},
	'cardsList': {
	    url: '/message/cards'
	},
	'cardsAdd': {
	    url: '/message/cards/addoredit'
	},
	'cardsDetail': {
	    url: '/message/cards/detail'
	},
	'cardsDel': {
	    url: '/message/cards/del'
	},
	'cardsUserinfo': {
	    url: '/message/cards/userinfo'
	},
	'cardsUserinfoRemark': {
	    url: '/message/cards/userinfo/remark'
	},
	'cardUrlLink': {
	    url: '/message/cards/url_link'
	},
	'client_upload': {
	    url: '/message/tool/client_upload'
	},
	'productsList': {
	    url: '/customer/preserve/method/products'
	},
	'chatMember': {
	    url: '/message/member'
	},
	'chatMsginfo': {
	    url: '/message/member/msginfo'
	},
	'chatSendMessage': {
	    url: '/message/send/message'
	},
	'chatMsgRead': {
	    url: '/message/member/msginfo/read'
	},
	
}
const requestFunObj = {}
for (const key in api) {
    requestFunObj[key]  = {
        mutationsName: api[key].mutationsName,
        requestFun:(params) => {
            return sendPost(api[key].url, params)
        }
    } 
}
export default requestFunObj
